import { getShiftedDatetimeHeader } from './shiftedDateTime';

export const getFetchHeaders = (headersFromParents: HeadersInit = {}) => {
  const headersShiftedDatetime = getShiftedDatetimeHeader();
  if (headersShiftedDatetime.time)
    return { ...headersFromParents, ...headersShiftedDatetime };
  return headersFromParents;
};
